import { DynamicFormLayoutType } from '../types/dynamic-form-layout.type';

export interface DynamicFormLayoutInterface {
  type?: DynamicFormLayoutType;
  key: string;
  label: string;
  elements?: DynamicFormLayout[];
  scope?: string;
  isDeleted?: boolean;
}
export class DynamicFormLayout {
  type!: DynamicFormLayoutType;
  key: string;
  label: string;
  elements!: DynamicFormLayout[];
  scope!: string;
  isDeleted: boolean;

  constructor(option: DynamicFormLayoutInterface) {
    this.key = option.key;
    this.label = option.label;
    this.isDeleted = !!option.isDeleted;
  }
}

export class DynamicFormGroupLayout extends DynamicFormLayout {
  override elements!: DynamicFormLayout[];
  constructor(option: DynamicFormLayoutInterface) {
    super(option);
    this.type = 'group';
    if (option.elements && Array.isArray(option.elements)) {
      this.elements = option.elements.map(element => new DynamicFormLayout(element));
    }
  }
}

export class DynamicFormControlLayout extends DynamicFormLayout {
  override scope: string;
  constructor(option: DynamicFormLayoutInterface) {
    super(option);
    this.type = 'control';
    this.scope = option.scope ? option.scope : '';
  }
}
